export default __webpack_public_path__ + "static/media/img-visionEearth.b8226e00.png";